export default __webpack_public_path__ + "static/media/calci.e5076f31.png";